import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import ButtonBase from "@mui/material/ButtonBase";
import React from "react";

import { useDispatch, useSelector } from "react-redux";
import {isSingleSleeperSelector, setBedSize} from "../../../redux/slices/mattressConfiguration";
import twinXL from "../../../assets/images/mattresSizes/twinXL.svg";
import queen from "../../../assets/images/mattresSizes/queen.svg";
import king from "../../../assets/images/mattresSizes/king.svg";
import caliKing from "../../../assets/images/mattresSizes/caliKing.svg";

import styled from "styled-components";

const StyledTitle = styled.div`
`;
const StyledSize = styled.div`
`;
const StyledPrice = styled.div`
`;

const StyledImageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`;

const BedSizes = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  const bedSize = useSelector(
    state => state.mattressConfiguration.mattressConfiguration.bedSize
  );

  const bedSizes = [
    {
      icon: twinXL,
      id: "twin",
      title: t("Twin XL"),
      size: '38" x 80"',
      price: "$1649",
    },
    {
      icon: queen,
      id: "queen",
      title: t("Queen"),
      size: '60" x 80"',
      price: "$2495",
    },
    {
      icon: king,
      id: "king",
      title: t("King"),
      size: '76" x 80"',
      price: "$2995",
    },
    {
      icon: caliKing,
      id: "caliKing",
      title: t("Cali-King"),
      size: '72" x 80"',
      price: "$2995",
    },
  ];

  const BedSizeItem = ({ title, size, price }) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <StyledTitle className={"styled-title"}>{title}</StyledTitle>
        <StyledSize className={"styled-size"}>{size}</StyledSize>
        <StyledPrice className={"styled-price"}>{price}</StyledPrice>
      </div>
    );
  };

  return (
    <div className="row mx-auto">
      {bedSizes.map((element, index) => {
        const isSelected = bedSize === element.id;
        return (
          <ButtonBase
            key={element.title}
            style={{
              width: "50%",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
            onClick={() => {
              dispatch(setBedSize(element.id));
            }}
            className={"bedsize-" + (((!isSingleSleeper) && index === 0) ? "disabled" : "enabled")}
            disabled={((!isSingleSleeper) && index === 0)}
          >
            <StyledImageContainer>
              <img
                className="bed-size-selector-button"
                style={{
                  backgroundColor: theme.COLORS.GREY.grey,
                  height: "6rem",
                  width: `${5 + (index + 1) * 0.5}rem`,
                  opacity: isSelected ? 1 : 0.5,
                }}
                src={element.icon}
              ></img>
            </StyledImageContainer>
            <BedSizeItem
              title={element.title}
              size={element.size}
              price={element.price}
            ></BedSizeItem>
          </ButtonBase>
        );
      })}
    </div>
  );
};

export default BedSizes;
